import Field from "@/components/Field";
import { FormLabel } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { useWeekdays } from "@/modules/projects/hooks/useWeekdays";
import { memo } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const WeekdaysFieldComponent = () => {
  const { getValues } = useFormContext();
  const { t } = useTranslation();
  const weekdays = useWeekdays();

  return (
    <>
      <FormLabel>{t("projectSchedules.fields.weekdays_label")}</FormLabel>
      <div className="flex flex-row gap-3">
        {weekdays.map((day) => (
          <Field
            key={day.value}
            name={`weekdays.${day.value}`}
            label={day.label}
            className="flex flex-row-reverse gap-2"
            render={({ field }) => (
              <Input
                className="h-4 w-4"
                type="checkbox"
                {...field}
                checked={getValues().weekdays[day.value]}
              />
            )}
          />
        ))}
      </div>
    </>
  );
};

export const WeekdaysField = memo(WeekdaysFieldComponent);
